module.exports = __webpack_public_path__ + "img/clouds_6.f1c4064a.png";